import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom'; // Importa useNavigate
import "../../../styles/principals/blog/blogArticle.css";

const BlogArticle = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Inicializa useNavigate

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/getEntry/${id}`);
        if (response.data && response.data.length > 0) {
          setArticle(response.data[0]);
        } else {
          throw new Error('No se encontró el artículo');
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching article: ", error);
        setLoading(false);
      }
    };    

    fetchArticle();
  }, [id]);

  useEffect(() => {
    // Esta función se ejecutará cuando cambie el artículo y se haya cargado
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Hace el scroll suave
      });
    };

    scrollToTop();
  }, [article]); // Ejecutar solo cuando el artículo cambie

  if (loading) {
    return <div className="blog-article-loading">Cargando...</div>;
  }

  if (!article) {
    return <div className="blog-article-error">Error al cargar el artículo</div>;
  }

  const tagNames = article.tagNames ? article.tagNames.split(',') : [];
  const tagColors = article.tagColors ? article.tagColors.split(',') : [];

  return (
    <div className="blog-article">
      <h1 className="blog-article-title">{article.title}</h1>
      <img className="blog-article-image" src={article.short_img} alt={article.title} />
      <p className="blog-article-content">{article.short_content}</p>
      <p className="blog-article-content">{article.content}</p>
      <div className="blog-article-footer">
        <div className="blog-article-tags">
          <strong>Tags: </strong>
          {tagNames.map((tag, index) => (
            <span key={index} className="blog-article-tag" style={{ backgroundColor: tagColors[index] }}>
              {tag.trim()}
            </span>
          ))}
        </div>
        <div className="back-button">
          <button className="home-button" onClick={() => navigate(-1)}>Volver</button>
        </div>
      </div>
    </div>
  );
};

export default BlogArticle;
